import React, { FC, SVGProps } from 'react';

export const BoostIncome: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="88"
    height="88"
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="88" height="88" rx="44" fill="#BAE1D1" />
    <rect
      x="32"
      y="32"
      width="24"
      height="24"
      rx="12"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M49 46.6028C49 44.8444 48.058 43.8346 45.8116 43.1904L43.4565 42.5462C42.2065 42.198 41.663 41.728 41.663 41.049C41.663 40.1088 42.6775 39.4124 43.9819 39.4472C45.3768 39.4646 46.4275 40.3003 46.6812 41.5365L48.9094 41.1534C48.4384 39.2035 47.1159 37.9499 45.1775 37.5843V36H43.0036V37.5495C40.8297 37.8455 39.4891 39.2035 39.4891 41.1534C39.4891 42.7203 40.4493 43.8172 42.2428 44.3569L45.3949 45.2797C46.4094 45.593 46.8442 46.0283 46.8442 46.7421C46.8442 47.7867 45.7572 48.5528 44.2536 48.5528C42.7138 48.5528 41.5181 47.6474 41.1739 46.2198L39 46.5506C39.3442 48.6398 40.8478 50.0675 43.0036 50.4331V52H45.1775V50.4505C47.4964 50.1197 49 48.6398 49 46.6028Z"
      fill="#26313B"
    />
    <rect
      x="16"
      y="27"
      width="56"
      height="34"
      rx="8"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
